import React from 'react'
import './FooterMe.css'
const FooterMe = () => {
  return (
    <>
   <footer className="footer mt-56">
    <div className="waves">
      <div className="wave" id="wave1"></div>
      <div className="wave" id="wave2"></div>
      <div className="wave" id="wave3"></div>
      <div className="wave" id="wave4"></div>
    </div>
  
    
    <p className="text-rose-500 bg-transparent">&copy;2022 Piyush Yadav | All Rights Reserved</p>
  </footer>
  <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
  <script noModule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
    </>
  )
}

export default FooterMe